module.exports = __webpack_public_path__ + "static/media/contract.b6a4fbb8.svg";